import { FvcAnalysisSetTest, FvcTest } from "webportalclient";
import { FvcTestAcceptabilitySummary, TestRepeatabilityResults, TestResults } from "./PFTAPITypes";

export interface FvcRepeatability {
    fvcAbsolute: number;
    fev1Absolute: number;
    pefAbsolute: number;

    fvcPercentage: number;
    fev1Percentage: number;
    pefPercentage: number;
}

export const calculateFvcRepeatabilityTopTwo = (testAcceptability: FvcTestAcceptabilitySummary[]): FvcRepeatability => {
    return {
        fvcAbsolute: calculateTopTwoAbsoluteRepeatability(testAcceptability, p => p.Fvc),
        fev1Absolute: calculateTopTwoAbsoluteRepeatability(testAcceptability, p => p.Fev1),
        pefAbsolute: calculateTopTwoAbsoluteRepeatability(testAcceptability, p => p.Pef),
        fvcPercentage: calculateTopTwoPercentageRepeatability(testAcceptability, p => p.Fvc),
        fev1Percentage: calculateTopTwoPercentageRepeatability(testAcceptability, p => p.Fev1),
        pefPercentage: calculateTopTwoPercentageRepeatability(testAcceptability, p => p.Pef),
    }
}

export const calculateFvcRepeatabilityTopTwoNew = (testAcceptability: FvcAnalysisSetTest[]): FvcRepeatability => {
    return {
        fvcAbsolute: calculateTopTwoAbsoluteRepeatabilityNew(testAcceptability, p => p.test.fvc),
        fev1Absolute: calculateTopTwoAbsoluteRepeatabilityNew(testAcceptability, p => p.test.fev1),
        pefAbsolute: calculateTopTwoAbsoluteRepeatabilityNew(testAcceptability, p => p.test.pefMin),
        fvcPercentage: calculateTopTwoPercentageRepeatabilityNew(testAcceptability, p => p.test.fvc),
        fev1Percentage: calculateTopTwoPercentageRepeatabilityNew(testAcceptability, p => p.test.fev1),
        pefPercentage: calculateTopTwoPercentageRepeatabilityNew(testAcceptability, p => p.test.pefMin),
    }
}

export const calculateTopTwoAbsoluteRepeatability = (testAcceptability: FvcTestAcceptabilitySummary[], parameterSelector: (parameter: FvcTestAcceptabilitySummary) => number) => {
    const topTwo = testAcceptability
        .filter(t => t.Accepted)
        .sort((a, b) => parameterSelector(b) > parameterSelector(a) ? 1 : parameterSelector(a) > parameterSelector(b) ? -1 : 0)
        .slice(0, 2);

    if (topTwo.length < 2) return null;

    return +(parameterSelector(topTwo[0]) - parameterSelector(topTwo[topTwo.length - 1])).toFixed(2);
}

export const calculateTopTwoAbsoluteRepeatabilityNew = (testAcceptability: FvcAnalysisSetTest[], parameterSelector: (parameter: FvcAnalysisSetTest) => number) => {
    const topTwo = testAcceptability
        .filter(t => t.accepted)
        .sort((a, b) => parameterSelector(b) > parameterSelector(a) ? 1 : parameterSelector(a) > parameterSelector(b) ? -1 : 0)
        .slice(0, 2);

    if (topTwo.length < 2) return null;

    return +(parameterSelector(topTwo[0]) - parameterSelector(topTwo[topTwo.length - 1])).toFixed(2);
}

export const calculateTopTwoPercentageRepeatability = (testAcceptability: FvcTestAcceptabilitySummary[], parameterSelector: (parameter: FvcTestAcceptabilitySummary) => number) => {
    const topTwo = testAcceptability
        .filter(t => t.Accepted)
        .sort((a, b) => parameterSelector(b) > parameterSelector(a) ? 1 : parameterSelector(a) > parameterSelector(b) ? -1 : 0)
        .slice(0, 2);

    if (topTwo.length < 2) return null;

    const numerator = parameterSelector(topTwo[0]) - parameterSelector(topTwo[topTwo.length - 1]);
    const denominator = (parameterSelector(topTwo[0]) + parameterSelector(topTwo[topTwo.length - 1])) / 2;
    return Math.abs(numerator / denominator) * 100;
}

export const calculateTopTwoPercentageRepeatabilityNew = (testAcceptability: FvcAnalysisSetTest[], parameterSelector: (parameter: FvcAnalysisSetTest) => number) => {
    const topTwo = testAcceptability
        .filter(t => t.accepted)
        .sort((a, b) => parameterSelector(b) > parameterSelector(a) ? 1 : parameterSelector(a) > parameterSelector(b) ? -1 : 0)
        .slice(0, 2);

    if (topTwo.length < 2) return null;

    const numerator = parameterSelector(topTwo[0]) - parameterSelector(topTwo[topTwo.length - 1]);
    const denominator = (parameterSelector(topTwo[0]) + parameterSelector(topTwo[topTwo.length - 1])) / 2;
    return Math.abs(numerator / denominator) * 100;
}
